import React, { PropTypes } from 'react';

const CloudinaryColumnHeaderIcon = () =>
    (
        <div>
            <img className="img-responsive cld-responsive cld-logo" src="https://res.cloudinary.com/idemo/image/upload/h_80,dpr_auto,c_scale/cloudinary_vertical_logo_for_white_bg_print.png" />
            <div>Multi-CDN</div>
        </div>
    );

export default CloudinaryColumnHeaderIcon;


/** WEBPACK FOOTER **
 ** ./src/js/components/MultiCdn/CloudinaryColumnHeaderIcon.js
 **/